import { RegVideo } from "../../../../src/posts/accordion-useref/Video.js";
import * as React from 'react';
export default {
  RegVideo,
  React
};